<div class="setup-membership-ui">

  <se-fe-card>
    <se-fe-card-content>
      <header class="setup-bar-header">
        <se-po-setup-bar
          [seFeDataTitle]="setupService.title"
          [percentage]="setupService.percentComplete"
        ></se-po-setup-bar>
      </header>

      <div class="page-content">

        <se-po-persona-picker-element
          (personaPicked)="onPick($event)"
          header="Who's this Membership for?"
        ></se-po-persona-picker-element>

      </div>

      <footer class="page-footer">
        <p><a href="https://www.sportsengine.com/solutions" seFeLink>What's SportsEngine?</a></p>
        <p>Need Help? <a href="https://intercom.help/SportsEngine/en/" seFeLink>SportsEngine Help Center</a></p>
      </footer>
    </se-fe-card-content>
  </se-fe-card>

  <footer class="se-footer">
    <a seFeLink
      target="_blank"
      href="https://www.sportsengine.com/privacy-center/terms-of-use"
      id="footer-link-terms-of-use"
      (click)="analyticsService.seEvent('TermsOfServiceClick')">Terms of Use</a> |
    <a seFeLink
      target="_blank"
      href="https://www.sportsengine.com/privacy-center/privacy-policy"
      id="footer-link-privacy-policy"
      (click)="analyticsService.seEvent('PrivacyPolicyClick')">Privacy Policy</a>
    <br>
    © SportsEngine, LLC. The Home of Youth Sports™. All Rights Reserved.
  </footer>
</div>
